/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

import favicon from "@/images/favicon.ico";

type Meta = {
	name: string;
	content: any;
	property?: undefined;
};

type Props = {
	description: string;
	lang: string;
	// meta: Meta;
	meta: any;
	title: string;
};

export const SEO = (props: Props) => {
	const { description, lang, meta, title } = props;

	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
					}
				}
			}
		`,
	);

	const metaDescription = description || site.siteMetadata.description;

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			titleTemplate={`%s | ${site.siteMetadata.title}`}
			link={[{ rel: "shortcut icon", type: "image/png", href: `${favicon}` }]}
			meta={[
				{ name: `description`, content: metaDescription },
				{ property: `og:title`, content: title },
				{ property: `og:description`, content: metaDescription },
				{ property: `og:type`, content: `website` },
				{ name: `twitter:card`, content: `summary` },
				{ name: `twitter:creator`, content: site.siteMetadata.author },
				{ name: `twitter:title`, content: title },
				{ name: `twitter:description`, content: metaDescription },
			].concat(meta)}
		/>
	);
};

SEO.defaultProps = {
	lang: `en`,
	meta: [],
	description: ``,
};

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired,
};
